import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useConfirmModal } from 'hooks';
import Button from 'components/Base/Button';
import messages from './messages';

interface Props {
  onConfirm: () => void;
}

const Confirm = ({ onConfirm }: Props): React.ReactElement => {
  const { formatMessage } = useIntl();
  const confirmAction = useConfirmModal();

  const onClick = (): void => {
    confirmAction({
      onConfirm,
      title: formatMessage(messages.confirmationHeading),
      content: formatMessage(messages.revokeWarning),
      confirmText: formatMessage(messages.revokeToken),
    });
  };

  return (
    <Button color="danger" style={{ height: 38 }} onClick={onClick}>
      <FormattedMessage {...messages['revokeToken']} />
    </Button>
  );
};

export default Confirm;
